import { render, staticRenderFns } from "./CreateUserForm.vue?vue&type=template&id=5722f65d&"
import script from "./CreateUserForm.vue?vue&type=script&lang=ts&"
export * from "./CreateUserForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateUserForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports